import { QueryBuilderTokenType } from '../../../../../../types';

export const startConditionValueSwap = (
  tokens: QueryBuilderTokenType[],
  tokenIndex: number
): QueryBuilderTokenType[] | null => {
  const token = tokens[tokenIndex];

  if (token?.type !== 'entityValue') {
    return null;
  }

  const nextTokens = [...tokens];
  nextTokens[tokenIndex] = { type: 'entity', entityKey: token.entityKey };

  return nextTokens;
};
